import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  botoesFormulario: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(3),
    width: '100%',
    alignItems: 'center',
  },
  camposFormulario: {
    marginTop: theme.spacing(2),
  },
  dividerBotoes: {
    marginBlock: theme.spacing(2),
  },
}))

export default useStyles
